module.exports = __webpack_public_path__ + "static/media/passkey.8f1bed1c.svg";